import { useCallback, useEffect, useState } from "react";

export const useResize = (size = 997) => {
  const [checked, setChecked] = useState(false);

  const resize = useCallback(() => {
    if (window.innerWidth <= size) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [size]);

  useEffect(() => {
    window.addEventListener("resize", resize);

    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [resize]);

  return checked;
};
